import { ACK_TEXT_MAX } from '@ralph/contracts'

/**
 * The builder's numbers, in one place and outside the catalogues (PRD-27 LOC-017, D-25).
 *
 * Every one of these used to sit as a literal inside the component that enforced it, which was
 * harmless while there was one language and stops being harmless the moment a catalogue is
 * copied per locale: a limit that lives beside the words gets copied with the words, and then
 * a Portuguese reader gets a different `maxLength` from an English one for the same field. A
 * validation limit is not copy, it is part of the contract with the server, and it must be
 * impossible for it to differ per reader.
 *
 * They are the contract's own limits, mirrored here so the field stops accepting characters at
 * the point the server would reject them rather than after a round trip.
 *
 * `STARTER_MAX_COUNT` is the one with a sentence attached: `marketplace.maker.sections.starters.full`
 * says "Four is the maximum." If this number ever changes, that sentence — and its Portuguese
 * twin — change with it, which is exactly the coupling worth being able to see in one grep.
 */

/** A name, a tagline, a description and an icon, as the maker plane's upsert types them. */
export const NAME_MAX = 120
export const TAGLINE_MAX = 80
export const DESCRIPTION_MAX = 2000
export const ICON_MAX = 8
export const CATEGORY_MAX = 60
export const INSTRUCTIONS_MAX = 24_000

/** Conversation starters: four, and each one a question rather than an essay. */
export const STARTER_MAX_COUNT = 4
export const STARTER_MAX = 200

/**
 * The contract's cap on the persisted acknowledgement (AGM-042), raised 30% for Portuguese
 * (PRD-27 LOC-041).
 *
 * It no longer mirrors the contract's number by hand — it IS the contract's number. A client cap
 * that drifted above the server's would turn a publish into a 400, and one that drifted below it
 * would silently decide what somebody agreed to, which is worse: an acknowledgement truncated by
 * a validation limit is a record of a sentence the person did not read to the end.
 *
 * Portuguese prose runs 15–25% longer than the English it is translated from, and the longest
 * consent sentence — a groups audience, several bases, several capabilities and a coverage gap
 * per base — is nearer the ceiling in Portuguese than in English. The headroom is deliberate.
 */
export const ACK_MAX = ACK_TEXT_MAX

/** The window the owner's knowledge-usage block reports over; matches the administrator's default. */
export const KNOWLEDGE_WINDOW_DAYS = 30
